import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Guides from './pages/Guides';
import About from './pages/About';
import Contact from './pages/Contact';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import UKGamblingRegulations2026 from './pages/news/UKGamblingRegulations2026';
import TopSlotsWinter2025 from './pages/news/TopSlotsWinter2025';
import DecemberBonuses2025 from './pages/news/DecemberBonuses2025';
import UKCasinoRevenue2025 from './pages/news/UKCasinoRevenue2025';
import CryptocurrencyPaymentsUK from './pages/news/CryptocurrencyPaymentsUK';
import PlayerProtectionTools2025 from './pages/news/PlayerProtectionTools2025';
import NewSlotReleases2025 from './pages/news/NewSlotReleases2025';
import MobileCasinoStatistics2025 from './pages/news/MobileCasinoStatistics2025';
import VIPProgramsRewardsUK from './pages/news/VIPProgramsRewardsUK';
import ChooseCasino from './pages/guides/ChooseCasino';
import UKRegulations from './pages/guides/UKRegulations';
import CasinoBonuses from './pages/guides/CasinoBonuses';
import PaymentMethods from './pages/guides/PaymentMethods';
import ResponsibleGambling from './pages/guides/ResponsibleGambling';
import RTPOdds from './pages/guides/RTPOdds';
import MobileCasino from './pages/guides/MobileCasino';
import LiveDealer from './pages/guides/LiveDealer';
import Withdrawals from './pages/guides/Withdrawals';
import Reviews from './pages/Reviews';
import Review32Red from './pages/reviews/32RedReview';
import ReviewHighbet from './pages/reviews/HighbetReview';
import ReviewPlayOJO from './pages/reviews/PlayOJOReview';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import CookiePolicy from './pages/CookiePolicy';
import ResponsibleGaming from './pages/ResponsibleGaming';
import AgeVerification from './components/AgeVerification';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AgeVerification />
      <CookieConsent />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/guides/choose-casino" element={<ChooseCasino />} />
        <Route path="/guides/uk-regulations" element={<UKRegulations />} />
        <Route path="/guides/casino-bonuses" element={<CasinoBonuses />} />
        <Route path="/guides/payment-methods" element={<PaymentMethods />} />
        <Route path="/guides/responsible-gambling" element={<ResponsibleGambling />} />
        <Route path="/guides/rtp-odds" element={<RTPOdds />} />
        <Route path="/guides/mobile-casino" element={<MobileCasino />} />
        <Route path="/guides/live-dealer" element={<LiveDealer />} />
        <Route path="/guides/withdrawals" element={<Withdrawals />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/reviews/32red-review" element={<Review32Red />} />
        <Route path="/reviews/highbet-review" element={<ReviewHighbet />} />
        <Route path="/reviews/playojo-review" element={<ReviewPlayOJO />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/uk-gambling-regulations-2026" element={<UKGamblingRegulations2026 />} />
        <Route path="/news/top-slots-winter-2025" element={<TopSlotsWinter2025 />} />
        <Route path="/news/december-bonuses-2025" element={<DecemberBonuses2025 />} />
        <Route path="/news/uk-casino-revenue-2025" element={<UKCasinoRevenue2025 />} />
        <Route path="/news/cryptocurrency-payments-uk" element={<CryptocurrencyPaymentsUK />} />
        <Route path="/news/player-protection-tools-2025" element={<PlayerProtectionTools2025 />} />
        <Route path="/news/new-slot-releases-2025" element={<NewSlotReleases2025 />} />
        <Route path="/news/mobile-casino-statistics-2025" element={<MobileCasinoStatistics2025 />} />
        <Route path="/news/vip-programs-rewards-uk" element={<VIPProgramsRewardsUK />} />
        <Route path="/news/:id" element={<NewsDetail />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
      </Routes>
    </Router>
  );
}

export default App;
